"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformCampaignRoutingKey = void 0;
var InformCampaignRoutingKey;
(function (InformCampaignRoutingKey) {
    InformCampaignRoutingKey["CreateAudienceMemberMessagesForEnrollment"] = "informCampaign_CreateAudienceMemberMessagesForEnrollment";
    InformCampaignRoutingKey["CreateAudienceMemberMessages"] = "informCampaign_CreateAudienceMemberMessages";
    InformCampaignRoutingKey["ExecuteInformCampaignEnrollment"] = "informCampaign_ExecuteInformCampaignEnrollment";
    InformCampaignRoutingKey["ExecuteInformCampaign"] = "informCampaign_ExecuteInformCampaign";
    InformCampaignRoutingKey["InformCampaignExecutionCompleted"] = "informCampaign_InformCampaignExecutionCompleted";
    InformCampaignRoutingKey["ProcessInformCampaignExecution"] = "informCampaign_ProcessInformCampaignExecution";
})(InformCampaignRoutingKey = exports.InformCampaignRoutingKey || (exports.InformCampaignRoutingKey = {}));
//# sourceMappingURL=types.js.map